import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteReisekostenabrechnungCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteReisekostenabrechnungCommandService],
  exports: []
})
export class DeleteReisekostenabrechnungCommandServiceModule { }
